/**
 * Helper mixing for root language support.
 * On init langauge should already be set.
 */
export default {
  created () {
    this.setLanguage()
    // this.$root.$on("setLocale", locale => {
    //   this.setLocale(locale)
    // })
  },
  methods: {
    setLanguage (language = null) {
      if (language === null) {
        language =
          sessionStorage.getItem("language") || process.env.VUE_APP_LANG
      }
      if (!this.$i18n.localeExists(language)) {
        let languageFile
        try {
          languageFile = require("@/lang/" + language + "/index.js").default
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn(this.$t("language.doesnt.exist", { lang: language }))
        }
        this.$i18n.add(language, languageFile)
      }
      this.$i18n.set(language)
      localStorage.setItem("locale", language)
    }
  }
}
